import { MemberRole } from "../graphql-types";

/**
 * Returns true if given role is specifically the 'owner' role
 */
export const isOwnerRole = (role: string | undefined) =>
  role === MemberRole.owner;
